import auth from "@/middleware/auth";
import hasRoles from "@/middleware/hasRoles";
import isUserNotBlocked from "@/middleware/isUserNotBlocked";
import isSmsVerified from "@/middleware/isSmsVerified";
import hasNoBillingData from "@/middleware/hasNoBillingData";
import isSmsNotVerified from "@/middleware/isSmsNotVerified";
import notAuth from "@/middleware/notAuth";
import isNotSelectedFacility from "@/middleware/isNotSelectedFacility";
import isDisabled from "@/middleware/isDisabled";

export default {
  path: "/auth",
  component: () =>
    import(/* webpackChunkName: "guest" */ "@/layouts/Guest.vue"),
  children: [
    {
      path: "register",
      children: [
        {
          path: "",
          name: "ChooseRegisterType",
          component: () =>
            import(
              /* webpackChunkName: "choose-register-type" */ "@/views/Auth/Doctor/Register/ChooseRegisterType.vue"
            ),
        },
        {
          path: "doctor",
          children: [
            {
              path: "",
              name: "DoctorRegisterForm",
              meta: {
                middlewares: [notAuth],
              },
              component: () =>
                import(
                  /* webpackChunkName: "choose-register-type-doctor" */ "@/views/Auth/Doctor/Register/DoctorRegisterForm.vue"
                ),
            },
            {
              path: "code",
              name: "DoctorVerifyPhoneNumber",
              meta: {
                middlewares: [
                  auth,
                  hasRoles,
                  isUserNotBlocked,
                  isSmsNotVerified,
                ],
                roles: ["doctor"],
              },
              component: () =>
                import(
                  /* webpackChunkName: "verify-phone-number" */ "@/views/Auth/Doctor/Register/PhoneVerify.vue"
                ),
            },
            {
              path: "office-name",
              name: "DoctorChooseOfficeName",
              meta: {
                middlewares: [auth, hasRoles, isUserNotBlocked],
                roles: ["doctor"],
              },
              component: () =>
                import(
                  /* webpackChunkName: "choose-office-name" */ "@/views/Auth/Doctor/Register/ChooseOfficeName.vue"
                ),
            },
            {
              path: "services",
              name: "DoctorServices",
              meta: {
                middlewares: [auth, hasRoles, isUserNotBlocked],
                roles: ["doctor"],
              },
              component: () =>
                import(
                  /* webpackChunkName: "doctor-services" */ "@/views/Auth/Doctor/Register/DoctorServices.ts.vue"
                ),
            },
            {
              path: "working-hours",
              name: "DoctorWorkingHours",
              meta: {
                middlewares: [auth, hasRoles, isUserNotBlocked],
                roles: ["doctor"],
              },
              component: () =>
                import(
                  /* webpackChunkName: "doctor-working-hours" */ "@/views/Auth/Doctor/Register/DoctorWorkingHours.ts.vue"
                ),
            },
          ],
        },
        {
          path: "clinic",
          meta: {
            middlewares: [isDisabled],
          },
          children: [
            {
              path: "",
              name: "ClinicRegisterForm",
              component: () =>
                import(
                  /* webpackChunkName: "choose-register-type" */ "@/views/Auth/Clinic/ClinicRegisterForm.vue"
                ),
            },
            {
              path: "code",
              name: "ClinicVerifyPhoneNumber",
              meta: {
                middlewares: [auth, hasRoles, isUserNotBlocked],
                roles: ["clinic_owner"],
              },
              component: () =>
                import(
                  /* webpackChunkName: "clinic-verify-phone-number" */ "@/views/Auth/Clinic/PhoneVerify.vue"
                ),
            },
            {
              path: "office-name",
              name: "ClinicChooseOfficeName",
              meta: {
                middlewares: [auth, hasRoles, isUserNotBlocked],
                roles: ["clinic_owner"],
              },
              component: () =>
                import(
                  /* webpackChunkName: "clinic-choose-office-name" */ "@/views/Auth/Clinic/ChooseOfficeNameAndSpecs.ts.vue"
                ),
            },
            {
              path: "services",
              meta: {
                middlewares: [auth, hasRoles, isUserNotBlocked],
                roles: ["clinic_owner"],
              },
              name: "ClinicServices",
              component: () =>
                import(
                  /* webpackChunkName: "clinic-services" */ "@/views/Auth/Clinic/ClinicServices.ts.vue"
                ),
            },
          ],
        },
      ],
    },
    {
      path: "doctor",
      children: [
        {
          path: "collection-facility",
          name: "AuthFalicityDoctor",
          meta: {
            middlewares: [
              auth,
              hasRoles,
              isUserNotBlocked,
              isNotSelectedFacility,
            ],
            roles: ["doctor"],
          },
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "auth-facility-doctor" */ "@/views/Auth/Doctor/Facility.vue"
            ),
        },
        {
          path: "billing-data",
          name: "AuthBillingDataDoctor",
          meta: {
            middlewares: [
              auth,
              hasRoles,
              isUserNotBlocked,
              isSmsVerified,
              hasNoBillingData,
            ],
            roles: ["doctor"],
          },
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "auth-billing-data-doctor" */ "@/views/Auth/Doctor/BillingData.vue"
            ),
        },
        {
          path: "login",
          name: "LoginDoctor",
          meta: {
            middlewares: [notAuth],
          },
          component: () =>
            import(
              /* webpackChunkName: "login-doctor" */ "@/views/Auth/Doctor/Login.vue"
            ),
        },
        {
          path: "create/:code",
          name: "DoctorAccountCreated",
          component: () =>
            import(
              /* webpackChunkName: "password-reset" */ "@/views/Auth/Doctor/AccountCreated.vue"
            ),
        },
      ],
    },
    {
      path: "password/email",
      name: "PasswordEmail",
      component: () =>
        import(
          /* webpackChunkName: "password-email" */ "@/views/Auth/Password/Email.vue"
        ),
    },
    {
      path: "password/reset/:code",
      name: "PasswordReset",
      component: () =>
        import(
          /* webpackChunkName: "password-reset" */ "@/views/Auth/Password/Reset.vue"
        ),
    },
  ],
};
